import React from "react";
import { useTranslation } from "react-i18next";
import { UI } from "@wwimmo/ui";
import { GetNewsDetailsById_newsitems } from "src/api/generated/GetNewsDetailsById";
import { NewsPreview } from "src/components/news/preview/NewsPreview";
import { NetworkConfig } from "src/network/NetworkConfig";
import { getHtmlStringForPreview } from "src/utils/HTMLUtils";

interface NewsEditReadOnlyProps {
    newsDetails?: GetNewsDetailsById_newsitems;
}

// A news whose realestates the user all has no access to. Whether it is for coowners or tenants is unknown then,
// so it is only shown and cannot be changed.
export const NewsEditReadOnly = ({ newsDetails }: NewsEditReadOnlyProps) => {
    const { t } = useTranslation();
    const news = newsDetails?.news[0];
    const image = newsDetails?.newsfileimage[0];

    return (
        <UI.Container className="pt-4 pb-5" fluid>
            <UI.Alert variant="info">{t("screens.realestate.news_edit.read_only_no_access")}</UI.Alert>
            <NewsPreview
                title={news?.title ?? ""}
                lead={news?.lead ?? ""}
                date={newsDetails?.timestamp}
                text={getHtmlStringForPreview(news?.text)}
                imageUrl={image ? NetworkConfig.openThumbnailUrl + image.fileid : ""}
                newsFiles={newsDetails?.newsfiles ?? []}
            />
        </UI.Container>
    );
};
